<div class="relative">
  <div *ngIf="menuService.disableSideBar" class="absolute w-full h-full left-0 top-0 z-[2] bg-[#FFFFFFB2]"></div>
  <div *ngFor="let menu of menuService.pagesMenu" class="pt-4">
    <div class="mx-1 mb-2 flex items-center justify-between">
        @if(menu.group){
            <small [ngClass]="{ hidden: !menuService.showSideBar }" class="text-xs text-normal font-semibold">
                {{ menu.group | translate}}
            </small>
        }
    </div>
    <ul class="flex flex-col space-y-1 gap-1">
      <!-- List items -->
      <li *ngFor="let item of menu.items" class="relative">
        <!-- Menu List -->
        <div class="group relative text-muted-foreground">
          <!-- Icon -->
            @if (item.icon){
                <div
                        [ngClass]="item.active && !menuService.showSideBar ? 'text-primary' : 'text-muted-foreground/50'"
                        class="pointer-events-none absolute m-2 text-normal">

                    <img alt="{{item.label}}" src="assets/{{item.icon}}" class="fill-white">


                </div>
            }


          <!-- Condition -->
          <ng-container
            [ngTemplateOutletContext]="{ item: item }"
            [ngTemplateOutlet]="item.children ? childMenu : parentMenu">
          </ng-container>

          <!-- Workaround:: Enable routerLink -->
          <ng-template #parentMenu let-item="item">
            <div *ngIf="item.route"
                 class="relative flex h-9 cursor-pointer text-normal items-center justify-start rounded-md text-muted-foreground  hover:text-primary transition-colors duration-300"
                 routerLink="{{ item.route }}"
                 routerLinkActive="border-r-[3px] border-primary text-primary">

              <a
                      *ngIf="menuService.showSideBar"
                      class=" ml-10 truncate text-sm font-semibold tracking-wide focus:outline-none"
                      appTooltip="{{item.label | translate}}"
                      [placement]="'right'"
                      [showIfTruncated]="true"
              >
                {{ item.label | translate}}
              </a>
            </div>
            <div *ngIf="!item.route"
                 class="flex h-9 text-normal transition-colors duration-300 items-center justify-start rounded text-muted-foreground hover:bg-card hover:text-primary">

              <a *ngIf="menuService.showSideBar"

                 class="ml-10 truncate text-xs font-semibold tracking-wide focus:outline-none">
                {{ item.label | translate}}
              </a>
            </div>
            <div *ngIf="item.disable" class="transition-colors duration-300 text-normal absolute w-full z-1 h-full left-0 top-0 bg-background-disable has-tooltip">
              <span class='tooltip rounded shadow-lg p-1   bg-primary -mt-8'>
                {{'coming_soon'| translate}}</span>
            </div>
          </ng-template>

          <!-- Workaround:: Disable routerLink -->
          <ng-template #childMenu let-item="item">
            <div class="flex h-9 cursor-pointer items-center justify-between rounded hover:bg-card"  (click)="toggleSubmenu(item, $event)">
              <a
                class="ml-10 truncate text-xs font-semibold tracking-wide text-normal focus:outline-none group-hover:text-normal">
                {{ item.label | translate}}
              </a>
                <button
                        *ngIf="item.children"
                        [ngClass]="{ hidden: !menuService.showSideBar, 'rotate-180': item.expanded }"
                        class="pointer-events-none relative z-10 top-1 right-0 flex items-center p-1 text-normal transition-all duration-500">
                    <svg viewBox="0 0 24 24" width="24">
                        <path xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd" d="M6.29289 8.79289C6.68342 8.40237 7.31658 8.40237 7.70711 8.79289L12 13.0858L16.2929 8.79289C16.6834 8.40237 17.3166 8.40237 17.7071 8.79289C18.0976 9.18342 18.0976 9.81658 17.7071 10.2071L12.7071 15.2071C12.3166 15.5976 11.6834 15.5976 11.2929 15.2071L6.29289 10.2071C5.90237 9.81658 5.90237 9.18342 6.29289 8.79289Z" fill="currentColor"/>
                    </svg>
                </button>

            </div>
          </ng-template>



          <!-- Tooltip -->
          <div *ngIf="!menuService.showSideBar && !item.disable" class=" w-full absolute">
          <span *ngIf="item.label"
            class="z-20 absolute left-14 -top-[34px] w-auto min-w-max origin-left scale-0 rounded-md bg-foreground p-2 text-xs font-bold text-normal shadow-md transition-all duration-200 group-hover:scale-100">
            {{ item.label | translate}}
          </span>
          </div>
        </div>

        <!-- Submenu items -->
        <app-admin-sidebar-submenu [submenu]="item"></app-admin-sidebar-submenu>
      </li>
    </ul>

    <div *ngIf="menu.separator" class="pt-3">
      <div class="h-[0px] border border-light-gray"></div>
    </div>

  </div>
</div>
